import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';
import { TeamChannelIcon } from '../teamChannelIcon';
import { getConversationGroups } from '../utils';
import styles from './teamChannelIconsList.module.scss';
export class TeamChannelIconsList extends PureComponent {
    render() {
        const { workloads_by_channel: workloads, fullPresence, limits, isSimultaneousRingingActive, } = this.props;
        const conversationGroups = getConversationGroups(workloads, limits, fullPresence);
        return (_jsxs(_Fragment, { children: [conversationGroups.map(({ id, icon, conversationCount, active, channels, tooltipContent }) => channels.length > 0 && (_jsx(Tooltip, Object.assign({ wrapProps: { className: styles.tooltipWrapper }, content: tooltipContent, dark: true }, { children: _jsx(TeamChannelIcon, { icon: icon, numberOfConversations: conversationCount, active: active }) }), id))), _jsx(TeamChannelIcon, { icon: "simultaneous-bold", active: isSimultaneousRingingActive })] }));
    }
}
